import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {
    getOperationEntitiesByGroupForDropDown,
    getCollectionCategoryByOperationEntityForDropDown,
    getCollectionPointsByOperationentityGroupID,
    getReportData
};

async function getOperationEntitiesByGroupForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllOperationEntities', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["groupID"] === parseInt(id) && item[1]["isActive"] === true)
            operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function getCollectionCategoryByOperationEntityForDropDown(id) {
    var collectionCategory = [];
    var response = await CommonGet('/api/CollectionCategory/GetCollectionCategoryByOperationEntityID', "operationEntityID=" + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true)
            collectionCategory[item[1]["collectionCategoryID"]] = item[1]["collectionCategoryName"];
    }
    return collectionCategory;
}

async function getCollectionPointsByOperationentityGroupID(operationEntityID, groupID) {
    var collectionPointArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["operationEntityID"] === parseInt(operationEntityID) && item[1]["groupID"] === parseInt(groupID) && item[1]["isActive"] === true) {
            collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return collectionPointArray;
}

async function getReportData(collectionPointID, startDate) {
    const response = await CommonGet('/api/LabourChecklistReport/GetLabourChecklistReportDetails', 'collectionPointID=' + parseInt(collectionPointID) + '&startDate=' + startDate);
    return response.data;
}

